<mat-card class="password-change-container">
  <mat-card-header>
    <img class="image-size" src="assets/themes/{{ themeService.currentLogo }}" />
    <h1>{{ 'password-change' | translate }}</h1>
  </mat-card-header>

  <form *ngIf="isIdValid; else errorContent"
        [formGroup]="formGroup"
        (ngSubmit)="onSubmit()">
    <mat-card-content>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'username' | translate }}</mat-label>
        <input matInput
               type="text"
               class="form-control"
               formControlName="username"
               required />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'password' | translate }}</mat-label>
        <input matInput
               [type]="hide ? 'password' : 'text'"
               class="form-control"
               formControlName="password"
               required
               autofocus
               (paste)="preventPaste($event)" />
        <mat-icon matSuffix (click)="hide = !hide">
          {{
          hide ? 'visibility_off' : 'visibility'
          }}
        </mat-icon>
      </mat-form-field>
      <app-password-strength [passwordToCheck]="formGroup.value.password"
                             (passwordStrength)="passwordValid($event)"
                             (passwordErrors)="getPasswordErrors($event)">
      </app-password-strength>
      <ul class="error">
        <li *ngFor="let error of passwordErrors">
          {{ error | translate }}
        </li>
      </ul>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'password-again' | translate }}</mat-label>
        <input matInput
               type="password"
               class="form-control"
               formControlName="passwordAgain"
               required
               (paste)="preventPaste($event)" />
      </mat-form-field>
      <ul class="error">
        <li *ngFor="let error of passwordAgainErrors">
          {{ error | translate }}
        </li>
      </ul>
    </mat-card-content>
    <mat-card-actions>
      <button type="submit"
              mat-raised-button
              color="primary"
              [disabled]="!(formGroup.valid && passwordIsValid)">
        {{ 'password-change' | translate }}
      </button>
    </mat-card-actions>
  </form>
  <ng-template #errorContent>
    <div id="errorContent">
      <mat-card-content>
        <h1>{{ 'pwd-change-error' | translate }}</h1>
        <h2>{{ 'pwd-change-link-expired' | translate }}</h2>
        <h2>{{ 'pwd-change-link-new-request' | translate }}</h2>
        <button mat-raised-button color="primary" (click)="backToLogin()">{{ 'back-to-login-btn' | translate }}</button>
      </mat-card-content>
    </div>
  </ng-template>
</mat-card>
